import { Component } from '@angular/core';
import { membersuiteSectionDuesProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Section Dues Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitesectionduesproduct-form',
    templateUrl: './membersuitesectionduesproduct.form.component.html'
})
export class membersuiteSectionDuesProductFormComponent extends BaseFormComponent {
    public record!: membersuiteSectionDuesProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

